// extracted by mini-css-extract-plugin
export default {"input":"Jca-z","button":"Kca-z","selected":"Lca-z","unavailable":"Mca-z","oos":"Nca-z","paperCutDisabledOverlay":"Oca-z","image":"Pca-z"};